import { deviceDetection } from '@pureadmin/utils'
const isMobile = deviceDetection()

export const DeviceUtils = {
  isMobile() {
    return isMobile
  },
}
